<!--
 * @Author: your name
 * @Date: 2021-07-29 14:40:27
 * @LastEditTime: 2021-09-24 21:36:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/CurAddress/index.vue
-->
<template>
  <div class="d-cur_address">
    <div
      class="address-content ellipsis finger-style"
      @click="openSelectAddress"
      v-if="poiDisplayName"
    >
      <i class="icon-outlined_adress"></i>
      <div class="poi-display-name ellipsis">{{ poiDisplayName }}</div>
      <i class="icon-outlinedpickup"></i>
    </div>
    <Addresscontent ref="addressRefs"></Addresscontent>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Addresscontent from './addresscontent.vue';
export default {
  name: 'CurAddress',
  components: {
    Addresscontent,
  },
  computed: {
    ...mapState({
      lastPoi: ({ address }) => address.lastPoi,
    }),
    poiDisplayName() {
      return this.lastPoi?.displayName || this.$t('地址');
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        this.getLastPoi();
      },
    },
  },
  methods: {
    ...mapActions('address', ['getLastPoi']),
    // 调用子组件的方法，打开弹层
    openSelectAddress() {
      this.$refs.addressRefs?.openSelectAddress();
    },
  },
};
</script>

<style lang="scss" scoped>
.d-cur_address {
  display: flex;
  justify-content: center;
  align-items: center;
  .address-content {
    display: flex;
    align-items: center;
    height: 20px;
    .icon-outlined_adress {
      font-size: 18px;
      margin-right: 8px;
    }
    .poi-display-name {
      max-width: 258px;
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 16px;
      position: relative;
      top: 1px;
    }
    .icon-outlinedpickup {
      font-size: 14px;
      margin-left: 5px;
      position: relative;
      top: 1px;
    }
  }
}

@media screen and (max-width: 768px) {
  .d-cur_address {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .address-content {
      height: rem(40);
      .icon-outlined_adress {
        font-size: rem(36);
        margin-right: rem(8) !important;
      }
      .poi-display-name {
        max-width: rem(280);
        font-size: rem(28);
        line-height: rem(32);
        position: relative;
        top: rem(2);
      }
      .icon-outlinedpickup {
        font-size: rem(28);
        margin-left: rem(4);
        position: relative;
        top: rem(2);
      }
    }
  }
}
</style>
